export const Endpoints = {
	// Auth
	login: "/auth/login/",
	refreshToken: "/auth/refresh-token/",
	checkEmail: "/auth/check-email/",
	requestResetPassword: "/auth/request-reset-password/",
	resetPassword: "/auth/reset-password/",

	// User
	signUp: "/auth/signup/",
	user: "/user/edit/",
	userLogged: "/user/logged/",
	userQrCode: "/user/qr-code/",
	userChatToken: "/user/chat-token/",

	// Apply Membership
	membershipPlansData: "/membership/plans-data/",
	applyMembership: "/membership/apply/",

	// Pay membership
	payMembership: "/membership/payment/",
	payMembershipSupportedCountries: "/membership/payment/supported-countries/",
	payMembershipStatus: "/membership/payment/status/",

	// Bookings
	myBookings: "/booking/my-bookings/",
	cancelBooking: "/booking/cancel/",

	// Book a space
	bookSpaceAllPlaces: "/book/space/all-places/",
	bookSpaceAvailableDays: "/book/space/available-days/",
	bookSpaceAvailableHours: "/book/space/available-hours/",
	bookSpace: "/book/space/",

	// Book a restaurant
	bookRestaurantAllPlaces: "/book/restaurant/all-places/",
	bookRestaurantAvailableDays: "/book/restaurant/available-days/",
	bookRestaurantAvailableHours: "/book/restaurant/available-hours/",
	bookRestaurantAvailableCapacity: "/book/restaurant/available-capacity/",
	bookRestaurant: "/book/restaurant/",
}
